<script>
import axios from "axios";
import Swal from "sweetalert2";
import Pagination from "@/router/layouts/table-pagination.vue";
import _ from "lodash";

export default {
  components: {
    Pagination,
  },

  emits: ["submit"],

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      idbatch: this.$route.params.idbatch,
      loadingTable: false,
      tableData: [],
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "created_at",
        dir: "desc",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },

      showImportManualView: false,
      isProccess: false,
      showProgress: false,
      totalData: 0,
      importedData: 0,
      isFinished: false,
      tempFile: "",
      lineFailed: [],
      totalSuccess: 0,
      totalFailed: 0,
    };
  },

  mounted() {
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
    this.getDataTable();
  },

  methods: {
    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("id-ID");
    },

    async getDataTable(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;

      const data = await axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "work-order",
        params: this.tableFilter,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });

      if (data) {
        this.tableData = data.data.data;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.data.last_page_url;
        this.pagination.nextPageUrl = data.data.next_page_url;
        this.pagination.prevPageUrl = data.data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
      }
      this.loadingTable = false;
    },

    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable(false);
    },

    addPesertaPembinaanGrade(idWorkOrder) {
      const idbatch = this.$route.params.idbatch;

      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      axios
        .post(
          this.BACKEND_URL_VERSION +
            `master/jadwal-pelaksanaan/${this.$route.params.id}/setup-jadwal/batch/jadwal-peserta/${idbatch}/import-peserta-pembinaan-grade/${idWorkOrder}`,
          {},
          {
            headers: { Authorization: `Bearer ${localStorage.access_token}` },
          }
        )
        .then(() => {
          Swal.fire("Berhasil!", "Peserta Pembinaan Grade berhasil ditambahkan.", "success");
          this.$emit("submit", true);
        })
        .catch((err) => {
          console.log("err add peserta pembinaan grade:", err);
          Swal.fire("Error!", "Terjadi kesalahan saat menambahkan peserta.", "error");
        });
    },

    async downloadTemplate() {
      let url =
        this.BACKEND_URL_VERSION + "download-template/peserta-kompetensi";
      window.open(url, "_blank");
    },

    resetImportManual() {
      this.showProgress = false;
      this.totalData = 0;
      this.importedData = 0;
      this.isFinished = false;
      this.tempFile = "";
      this.isProccess = false;
      this.lineFailed = [];
      this.totalSuccess = 0;
      this.totalFailed = 0;
      if (this.$refs.fileInputKompetensi) {
        this.$refs.fileInputKompetensi.value = "";
      }
    },

    handleFileChangeKompetensi(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file);

      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      axios
        .post(
          this.BACKEND_URL_VERSION +
            `master/jadwal-pelaksanaan/${this.$route.params.id}/setup-jadwal/batch/jadwal-peserta/${this.idbatch}/preview-import-peserta-kompetensi`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          this.totalData = response.data.data.total;
          this.tempFile = response.data.data.tempFile;
          Swal.fire({
            icon: "info",
            title: "Preview Data",
            html: `<p>Total Data: ${this.totalData}</p>`,
            showCancelButton: true,
            confirmButtonText: "Import Data",
            cancelButtonText: "Batal",
          }).then((result) => {
            if (result.isConfirmed) {
              this.submitImportManual();
            }
          });
        })
        .catch((error) => {
          console.error("Preview Error:", error);
          Swal.fire("Error!", "Terjadi kesalahan saat membaca file.", "error");
        });
    },

    submitImportManual() {
      this.showProgress = true;
      const chunkSize = 25;
      const totalChunks = Math.ceil(this.totalData / chunkSize);
      let currentChunk = 0;
      this.importedData =
        currentChunk * chunkSize > this.totalData
          ? this.totalData
          : currentChunk * chunkSize;

      const importChunk = () => {
        this.isProccess = true;
        if (currentChunk >= totalChunks) {
          this.isFinished = true;
          this.showProgress = false;
          this.isProccess = false;
          Swal.fire("Import selesai!", "Semua data telah diimport.", "success");
          this.$emit("submit", true);
          return;
        }

        axios
          .post(
            this.BACKEND_URL_VERSION +
              `master/jadwal-pelaksanaan/${this.$route.params.id}/setup-jadwal/batch/jadwal-peserta/${this.idbatch}/import-peserta-kompetensi`,
            {
              tempFile: this.tempFile,
              chunk: currentChunk,
              chunkSize: chunkSize,
              idbatch: this.idbatch,
            },
            {
              headers: { Authorization: `Bearer ${localStorage.access_token}` },
            }
          )
          .then((response) => {
            currentChunk++;
            this.importedData = Math.min(
              currentChunk * chunkSize,
              this.totalData
            );
            this.totalSuccess += response.data.data.success || 0;
            this.totalFailed += response.data.data.failed || 0;
            this.lineFailed = [
              ...this.lineFailed,
              ...(response.data.data.lineFailed || []),
            ];
            importChunk();
          })
          .catch((error) => {
            this.isProccess = false;
            console.error("Import Error:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat import.", "error");
          });
      };

      importChunk();
    },
  },
};
</script>

<template>
  <div>
    <!-- Tampilan daftar work order -->
    <template v-if="!showImportManualView">
      <div class="row mb-2">
        <div class="col-12 mb-2 text-end">
          <button
            class="btn btn-success btn-sm"
            @click="resetImportManual(); showImportManualView = true"
          >
            <i class="fa fa-upload me-1"></i> Import Manual
          </button>
        </div>
        <div class="col-12">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Cari kode / keterangan..."
            v-model="tableFilter.search"
            @input="filterData()"
          />
        </div>
      </div>

      <div class="table-responsive mb-0">
        <table class="table align-middle table-nowrap text-center">
          <thead class="table-dark">
            <tr>
              <th class="align-middle">Kode</th>
              <th class="align-middle">Keterangan</th>
              <th class="align-middle">Created At</th>
              <th class="align-middle">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loadingTable">
              <td colspan="4" class="text-center">
                <i class="fas fa-spinner fa-spin"></i> Loading
              </td>
            </tr>
            <tr v-else-if="tableData.length < 1">
              <td colspan="4" class="text-center">Data Empty</td>
            </tr>
            <tr v-else v-for="(row, index) in tableData" :key="index">
              <td>{{ row.kode }}</td>
              <td>{{ row.keterangan }}</td>
              <td>{{ formatDate(row.created_at) }}</td>
              <td class="text-center">
                <button
                  class="btn btn-success btn-sm"
                  @click="addPesertaPembinaanGrade(row.id_work_order)"
                >
                  <i class="fa fa-plus me-1"></i> Add Peserta Pembinaan Grade
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @to-page="toPage"></Pagination>
    </template>

    <!-- Tampilan import manual, menggantikan konten di atas (bukan popup baru) -->
    <template v-else>
      <div class="row mb-2">
        <div class="col-12">
          <button
            class="btn btn-outline-secondary btn-sm"
            @click="showImportManualView = false"
          >
            <i class="fa fa-arrow-left me-1"></i> Kembali
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-2">
          <button class="btn btn-success btn-sm" @click="downloadTemplate()">
            <i class="fa fa-download me-1"></i> Download Template
          </button>
        </div>

        <div class="col-12 mb-3">
          <label for="file" class="form-label">Select File</label>
          <input
            type="file"
            ref="fileInputKompetensi"
            class="form-control"
            @change="handleFileChangeKompetensi"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :disabled="isProccess"
          />
        </div>

        <div class="alert alert-success" role="alert" v-if="isFinished">
          <h4 class="alert-heading">Import Peserta Pembinaan Grade Selesai</h4>
          <table>
            <tr>
              <td>Total Data</td>
              <td>:</td>
              <td>{{ totalData }}</td>
            </tr>
            <tr>
              <td>Total Berhasil</td>
              <td>:</td>
              <td>{{ totalSuccess }}</td>
            </tr>
            <tr>
              <td>Total Gagal</td>
              <td>:</td>
              <td>{{ totalFailed }}</td>
            </tr>
            <tr v-if="lineFailed.length > 0">
              <td>Baris Gagal</td>
              <td>:</td>
              <td>
                <template v-for="(line, index) in lineFailed" :key="index">
                  <span v-if="index < lineFailed.length">{{ line }},</span>
                  <span v-else>{{ line }}</span>
                </template>
              </td>
            </tr>
            <tr v-else>
              <td colspan="3" class="text-center">Tidak ada baris yang gagal</td>
            </tr>
          </table>
        </div>

        <div class="row mt-3" v-if="showProgress">
          <b-progress :max="totalData" height="2rem">
            <b-progress-bar :value="importedData" show-progress animated>
              <span>
                Progress: <strong>{{ importedData }} / {{ totalData }}</strong>
              </span>
            </b-progress-bar>
          </b-progress>
        </div>
      </div>
    </template>
  </div>
</template>
